let online = true;

export function setOfflineOnlineFlag(value: boolean): void {
  online = value;
}

export function isOfflineOnline(): boolean {
  return online;
}
